/* Pudel cart helpers (v13)
   - Add-on line ("Add the Test Pack") posts to /cart/add.js
   - Discount code field posts to /cart/update.js { discount }
   Both then repaint whichever cart UI is on the page:
     · cart_type = drawer → <cart-drawer>.renderContents() (Dawn's own repaint)
     · cart page          → replace the .js-contents of main-cart-items / main-cart-footer
   Event delegation on document, so markup that is re-rendered by Dawn keeps working. */
(function () {
  'use strict';

  function routes() {
    var r = window.routes || {};
    return {
      add: r.cart_add_url || '/cart/add',
      update: r.cart_update_url || '/cart/update',
      cart: r.cart_url || '/cart'
    };
  }

  /* On the cart page the page's own sections repaint (and the drawer, if present,
     is refreshed too so it is not stale when opened). Everywhere else the drawer is
     the cart UI and Dawn's renderContents() repaints and opens it. */
  function sectionsToRender() {
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    var drawer = document.querySelector('cart-drawer');
    var out = [];
    if (items || footer) {
      if (items) out.push({ id: 'main-cart-items', section: items.dataset.id, selector: '.js-contents' });
      if (footer) out.push({ id: 'main-cart-footer', section: footer.dataset.id, selector: '.js-contents' });
      if (drawer) out.push({ id: 'cart-drawer', section: 'cart-drawer', selector: '#CartDrawer' });
      out.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
      return { mode: 'page', list: out };
    }
    out.push({ id: 'cart-drawer', section: 'cart-drawer', selector: '#CartDrawer' });
    out.push({ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' });
    return { mode: drawer ? 'drawer' : 'none', list: out };
  }

  function replaceInner(hostSelector, html, innerSelector) {
    var host = document.querySelector(hostSelector);
    if (!host || !html) return;
    var target = (innerSelector && host.querySelector(innerSelector)) || host;
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector(innerSelector || 'body');
    if (target && fresh) target.innerHTML = fresh.innerHTML;
  }

  function repaint(parsed, plan) {
    if (!parsed || !parsed.sections) { window.location.href = routes().cart; return; }
    if (plan.mode === 'drawer') {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') { drawer.renderContents(parsed); return; }
    }
    if (plan.mode === 'none') { window.location.href = routes().cart; return; }
    plan.list.forEach(function (s) {
      var html = parsed.sections[s.section] || parsed.sections[s.id];
      if (!html) return;
      if (s.id === 'cart-drawer') { replaceInner('#CartDrawer', html, null); return; }
      if (s.id === 'cart-icon-bubble') { replaceInner('#cart-icon-bubble', html, '.shopify-section'); return; }
      replaceInner('#' + s.id, html, s.selector);
    });
    // Cart page: an empty→non-empty flip needs the full page, not a partial.
    if (parsed.item_count === 0) window.location.href = routes().cart;
  }

  function busy(btn, on) {
    if (!btn) return;
    if (on) {
      btn.dataset.restore = btn.textContent;
      btn.textContent = btn.dataset.pending || btn.textContent;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
    } else {
      if (btn.dataset.restore) btn.textContent = btn.dataset.restore;
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    }
  }

  function headers() {
    return { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
  }

  /* ---------- add-on line ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-pudel-addon-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[data-pudel-addon-btn]');
    var err = form.parentNode.querySelector('.pudel-addon__err');
    var plan = sectionsToRender();
    var body = {
      items: [{ id: form.querySelector('[name="id"]').value, quantity: 1 }],
      sections: plan.list.map(function (s) { return s.section; }),
      sections_url: window.location.pathname
    };
    busy(btn, true);
    if (err) err.hidden = true;
    fetch(routes().add + '.js', { method: 'POST', headers: headers(), body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (parsed) {
        if (parsed.status && parsed.status >= 400) throw new Error(parsed.description || 'add failed');
        repaint(parsed, plan);
        document.dispatchEvent(new CustomEvent('cart:add', { detail: parsed }));
      })
      .catch(function () {
        busy(btn, false);
        if (err) { err.textContent = btn ? (btn.dataset.error || '') : ''; err.hidden = false; }
      });
  });

  /* ---------- discount code ---------- */
  function applyDiscount(codes, btn, errEl) {
    var plan = sectionsToRender();
    var body = {
      discount: codes,
      sections: plan.list.map(function (s) { return s.section; }),
      sections_url: window.location.pathname
    };
    busy(btn, true);
    if (errEl) errEl.hidden = true;
    return fetch(routes().update + '.js', { method: 'POST', headers: headers(), body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (parsed) {
        if (parsed.status && parsed.status >= 400) throw new Error('update failed');
        var wanted = codes.split(',').map(function (c) { return c.trim().toUpperCase(); }).filter(Boolean);
        var got = (parsed.discount_codes || []).filter(function (d) { return d.applicable; })
          .map(function (d) { return String(d.code).toUpperCase(); });
        var missing = wanted.filter(function (c) { return got.indexOf(c) === -1; });
        if (missing.length && wanted.length) {
          busy(btn, false);
          if (errEl) errEl.hidden = false;
          return;
        }
        repaint(parsed, plan);
      })
      .catch(function () {
        busy(btn, false);
        if (errEl) errEl.hidden = false;
      });
  }

  function currentCodes(scope) {
    return Array.prototype.map.call(scope.querySelectorAll('[data-pudel-discount-remove]'), function (b) {
      return b.getAttribute('data-pudel-discount-remove');
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-pudel-discount-form]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('input[name="discount"]');
    var code = (input.value || '').trim();
    if (!code) { input.focus(); return; }
    var scope = form.closest('[data-pudel-discount]');
    var codes = currentCodes(scope).concat([code]).join(',');
    applyDiscount(codes, form.querySelector('[data-pudel-discount-btn]'), form.querySelector('[data-pudel-discount-err]'));
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-pudel-discount-remove]');
    if (!btn) return;
    e.preventDefault();
    var scope = btn.closest('[data-pudel-discount]');
    var remaining = currentCodes(scope).filter(function (c) { return c !== btn.getAttribute('data-pudel-discount-remove'); });
    applyDiscount(remaining.join(','), null, scope.querySelector('[data-pudel-discount-err]'));
  });
})();
